<template>
    <section class="bg-white py-4 px-4 rounded-2xl flex flex-col h-full">
        <h1 class="text-xl text-primary font-bold">Desempenho Nespoints</h1>
        <p class="text-sm">Desempenho na Campanha Nespoints</p>
        <div class="flex-grow">
            <div class="flex justify-center items-center bg-gray-100 h-full w-full py-5 px-5 mt-2 rounded-2xl min-h-[20vh]">
                <Loading v-if="isLoading" size="10" />
                <div v-else-if="!!!teamPerformance?.total" class="relative">
                    <div class="outer w-[120px] h-[120px] rounded-[50%] p-5 bg-[#79FF9D]">
                        <div class="inner h-[80px] w-[80px] rounded-[50%] flex justify-center items-center bg-white">
                            <div id="number" class="font-semibold text-primary text-[20px]">
                                ***%
                            </div>
                        </div>
                    </div>
                    <svg class="absolute top-0 left-0" xmlns="http://www.w3.org/2000/svg" version="1.1" width="160px" height="160px">
                        <defs>
                        <linearGradient id="GradientColor">
                            <stop offset="0%" stop-color="#e91e63" />
                            <stop offset="100%" stop-color="#673ab7" />
                        </linearGradient>
                        </defs>
                        <circle class="progress-bar fill-[none] stroke-[#0771c5] stroke-[20px]" cx="60px" cy="60px" r="50" stroke-linecap="round" />
                    </svg>
                    <div class="flex flex-col text-primary">
                        <p><strong>META</strong>: ***</p>
                        <p><strong>REALIZADO</strong>: ***</p>
                        <p v-if="participantPerformance"><strong>MEU RESULTADO</strong>: ****</p>
                        <a class="cursor-pointer text-[black]" @click="handleDataUpdate()" style="font-siza: 0.8rem">
                            Ver performance
                        </a>
                    </div>
                </div>
                <div v-else class="relative">
                    <div class="outer w-[120px] h-[120px] rounded-[50%] p-5 bg-[#79FF9D]">
                        <div class="inner h-[80px] w-[80px] rounded-[50%] flex justify-center items-center bg-white">
                            <div id="number" class="font-semibold text-primary text-[20px]">
                                {{progressValue}}%
                            </div>
                        </div>
                    </div>
                    <svg class="absolute top-0 left-0" xmlns="http://www.w3.org/2000/svg" version="1.1" width="160px" height="160px">
                        <defs>
                        <linearGradient id="GradientColor">
                            <stop offset="0%" stop-color="#e91e63" />
                            <stop offset="100%" stop-color="#673ab7" />
                        </linearGradient>
                        </defs>
                        <circle class="progress-bar fill-[none] stroke-[#0771c5] stroke-[20px]" cx="60px" cy="60px" r="50" stroke-linecap="round" />
                    </svg>
                    <div class="flex flex-col text-primary">
                        <p><strong>META</strong>: {{teamPerformance?.total}}</p>
                        <p><strong>REALIZADO</strong>: {{teamPerformance?.achieved}}</p>
                        <p v-if="participantPerformance"><strong>MEU RESULTADO</strong>: {{participantPerformance?.achieved}}</p>
                        <a class="cursor-pointer text-[black]" @click="handleDataUpdate()" style="font-siza: 0.8rem">
                            Atualizar dados
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="xl:flex items-center flex-wrap gap-y-1 justify-between pt-4 pb-2">
            <div class="text-sm flex flex-col justify-between text-gray-600">
                <p class="text-[10px] text-left flex items-center">Última atualização: {{ lastUpdate ? formatUpdatedDate(lastUpdate) : getCurrentDate() }}</p>
                <a :href="route('performance')" class="flex items-center gap-x-1 sm:mt-3">Conferir desempenho detalhado <Icon name="ArrowRight" class="translate-y-[1px]"/></a>
            </div>
        </div>
    </section>
</template>
<script>
import Icon from "@/Components/UI/Icons/Icon.vue"
import Loading from '@/Components/Loading.vue'
import moment from 'moment'
export default {
    components: {
        Loading,
        Icon,
    },
    props: {
        isLoading: Boolean,
        teamPerformance: Object,
        participantPerformance: Object,
    },
    emits: ['requestPerformanceUpdate'],
    computed: {
        progressValue() {
            return this.getPercent(this.teamPerformance?.achieved);
        },
        progressCssValue() {
            if(this.progressValue >= 100) {
                return 0;
            }
            return 320 - (this.progressValue * 3.2);
        },
    },
    methods: {
        handleDataUpdate() {
            this.$emit("requestPerformanceUpdate");
        },
        getCurrentDate : function () {
            return new moment().format('DD/MM/YYYY [às] HH:mm');
        },
        getPercent(progress) {
            if (!this.teamPerformance?.total) return 0;
            const total = this.teamPerformance?.total || 100;
            const partial = progress || 0;
            return parseInt((100 * partial) / total)
        },
        getProgressPercent(progress) {
            if (!this.teamPerformance?.achieved) return 0;
            const total = this.teamPerformance?.achieved || 100;
            const partial = progress || 0;
            return parseInt((100 * partial) / total)
        },
    }
}
</script>
<style scoped>
.progress-bar {
    stroke-dasharray: 320;
    stroke-dashoffset: v-bind(progressCssValue);
    animation: anim 2s linear forwards;
}
</style>
